import React from "react";
import { Loader2 } from "lucide-react";

export function Spinner({ label = "Loading…" }) {
  return (
    <div className="flex items-center gap-2 text-sm text-muted-foreground py-10 justify-center">
      <Loader2 className="animate-spin" size={16} /> {label}
    </div>
  );
}

const HEALTH = {
  on_track: { label: "On track", cls: "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400 border-emerald-500/30" },
  at_risk: { label: "At risk", cls: "bg-[#c9a227]/15 text-[#a6821a] dark:text-[#e0b838] border-[#c9a227]/30" },
  off_track: { label: "Off track", cls: "bg-red-500/15 text-red-600 dark:text-red-400 border-red-500/30" },
};

export function HealthBadge({ status = "on_track" }) {
  const h = HEALTH[status] || HEALTH.on_track;
  return (
    <span className={`inline-flex items-center gap-1.5 text-xs font-medium px-2.5 py-1 rounded-full border ${h.cls}`} data-testid={`health-${status}`}>
      <span className="w-1.5 h-1.5 rounded-full bg-current" /> {h.label}
    </span>
  );
}

export function StatCard({ icon: Icon, label, value, accent = "cyan", testid }) {
  const colors = { cyan: "text-[#29abe2] bg-[#29abe2]/10", navy: "text-[#0f2557] dark:text-[#5a9fdc] bg-[#0f2557]/10 dark:bg-[#29abe2]/10", gold: "text-[#a6821a] dark:text-[#e0b838] bg-[#c9a227]/15" };
  return (
    <div className="rounded-xl border bg-card p-5 card-hover" data-testid={testid}>
      <div className="flex items-center justify-between">
        <span className={`grid place-items-center w-10 h-10 rounded-lg ${colors[accent]}`}>{Icon && <Icon size={18} />}</span>
      </div>
      <div className="mt-3 text-2xl font-bold text-foreground">{value}</div>
      <div className="text-xs text-muted-foreground mt-0.5 uppercase tracking-wider font-medium">{label}</div>
    </div>
  );
}

export function SectionTitle({ eyebrow, title, action }) {
  return (
    <div className="flex items-end justify-between mb-4">
      <div>
        {eyebrow && <div className="text-[11px] font-semibold tracking-[0.18em] text-[#29abe2] uppercase mb-1">{eyebrow}</div>}
        <h2 className="text-xl sm:text-2xl font-semibold text-foreground tracking-tight">{title}</h2>
      </div>
      {action}
    </div>
  );
}

export function Empty({ title, hint, action }) {
  return (
    <div className="rounded-xl border border-dashed bg-card/50 p-12 text-center">
      <div className="text-base font-medium text-foreground">{title}</div>
      {hint && <div className="text-sm text-muted-foreground mt-1.5 max-w-md mx-auto">{hint}</div>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export function Confidence({ value }) {
  const v = Math.round(value > 1 ? value : value * 100);
  const color = v >= 80 ? "text-emerald-600 dark:text-emerald-400" : v >= 55 ? "text-[#a6821a] dark:text-[#e0b838]" : "text-red-500";
  return <span className={`text-xs font-semibold ${color}`}>{v}%</span>;
}
